import * as yup from 'yup';
import { tErrorKey } from '../helpers/translate';

const requiredText = tErrorKey('Este campo es obligatorio');

export const AreasEditionSchema = yup.object().shape({
  name: yup.string().required(requiredText),
});
